// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__3O7KY","overflowing":"ReadFullNote_overflowing__-ZD7o"};